import { useLocation, Navigate, useNavigate } from 'react-router-dom';
import { useAuthContext } from '@hooks/useAuthContext';
import request from '@api';
import queryString from 'query-string';
import { useEffectOnce } from '@hooks';
import FullpageLoading from '../../components/FullpageLoading';

export default function Auth() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, updateUser } = useAuthContext();

  if (login) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  useEffectOnce(() => {
    const authenticate = async () => {
      const { token } = queryString.parse(window.location.search);
      const sessionToken = localStorage.getItem('sessionToken');
      if (!token) {
        return;
      }
      const res = await request('authenticate', {
        method: 'POST',
        body: { token, sessionToken },
      }).catch(console.log);

      if (res.code === 0) {
        await updateUser().catch();
        navigate('/');
      }
      localStorage.removeItem('sessionToken');
    };
    authenticate();
  }, []);

  return <FullpageLoading />;
}
